import { render, staticRenderFns } from "./CreateAttributeModal.vue?vue&type=template&id=67120f0a&scoped=true"
import script from "./CreateAttributeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAttributeModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateAttributeModal.vue?vue&type=style&index=0&id=67120f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67120f0a",
  null
  
)

export default component.exports